module.exports = __webpack_public_path__ + "img/phone.ada224b8.png";